<template>
    <a-card :bordered="false" class="export-center">
        <a-row :gutter="20" v-show="!selectType.value">
          <a-col :span="10">
            <div class="title" v-has="'export:CRFdata'">采集数据</div>
            <div class="row2">
              <a-button class="btn" @click="exportConfig('1')" v-has="'export:CRFdata'">采集数据导出（按周期）</a-button>
              <a-button class="btn" @click="exportConfig('2')" v-has="'export:CRFdata'">采集数据导出（按表单）</a-button>
              <a-button class="btn" @click="exportConfig('3')" v-has="'export:CRFConfig'">CRF注释信息</a-button>
              <a-button class="btn" @click="exportConfig('10')" v-has="'export:CRFConfig'">CRF注释信息历史版本 </a-button>
            </div>
            <div class="title row" >受试者数据</div>
            <div class="row2">
              <a-button class="btn" @click="exportConfig('4')" v-has="'export:patientInfo'">受试者注册信息导出</a-button>
              <a-button class="btn" @click="exportConfig('5')" v-has="'export:patientInfo'">终止筛选信息</a-button>
              <a-button class="btn" @click="exportConfig('6')" v-has="'export:patientInfo'">终止随访信息</a-button>
              <!--<a-button class="btn" @click="exportConfig('7')" v-has="'export:randomGroup'">随机分组信息</a-button>-->
              <a-button class="btn" @click="exportConfig('12')" v-has="'export:patientAudit'">受试者审核状态</a-button>
              <a-button class="btn" @click="exportConfig('16')" v-has="'export:templateInfo'">知情同意书信息</a-button>
            </div>
            <div class="title row" v-has="'export:question'">质疑数据</div>
            <div class="row2">
              <a-button class="btn" @click="exportConfig('8')" v-has="'export:question'">质疑记录导出</a-button>
            </div>
            <div class="title row" v-has="'export:formula'">配置信息</div>
            <div class="row2">
              <a-button class="btn" @click="exportConfig('9')" v-has="'export:formula'">公式配置</a-button>
            </div>
            <div class="title row" v-has="'export:scheme'">项目方案</div>
            <div class="row2">
              <a-button class="btn" @click="exportConfig('11')" v-has="'export:scheme'">项目方案导出</a-button>
            </div>
          </a-col>
          <a-col :span="14">
            <div class="title">数据导出记录</div>
            <div class="search-panel">
              导出时间：
               <a-range-picker v-model:value="queryParamDateRange" @change="queryParamDateRangeChange" valueFormat="YYYY-MM-DD" style="width:30%"/>
              <!-- 数据类型：
              <a-select v-model="queryParam.type" placeholder="请选择" style="width: 200px" allowClear >
                <a-select-option :value="item.value" v-for="(item,index) in typeList" :key="index">{{item.text}}</a-select-option>
              </a-select> -->
              <a-button class="search-item-com" type="primary" @click="searchQuery">查询</a-button>
              <a-button class="search-item-com" @click="searchReset">重置</a-button>
            </div>
            <a-table
              ref="table"
              size="middle"

              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <template v-if="record.status==='2'">
            <template v-if="record.createBy === userInfo().username">
              <a @click="handleDownload(record)" >下载</a>
            <!-- <a-divider type="vertical"/> -->
            </template>
          </template>
           <template >
              <a-divider type="vertical" v-has="'export:deleteRecord'"/>
              <a-popconfirm v-has="'export:deleteRecord'" title="确定删除该记录吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </template>
             <template >
              <a-divider type="vertical"/>
               <a @click="handleView(record)">查看</a>
            </template>
        
        </span>
            </a-table>
          </a-col>
        </a-row>
        <export-config v-show="selectType.value" :type="selectType" @back="back"></export-config>
    </a-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import ExportConfig from './center/ExportConfig'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import { getAction,postAction,downloadFile } from '@/api/manage'
  import Vue from 'vue'
  export default {
    name: 'Center',
    components: { ExportConfig },
    mixins: [JeecgListMixin],
    data(){
      return{
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParamDateRange:[],
        typeList:[
          {value:'1',text:'采集数据导出（按周期）'},
          {value:'2',text:'采集数据导出（按表单）'},
          {value:'3',text:'CRF注释信息'},
          {value:'10',text:'CRF注释信息历史版本'},
          {value:'4',text:'受试者注册信息导出'},
          {value:'5',text:'终止筛选信息'},
          {value:'6',text:'终止随访信息'},
          {value:'7',text:'随机分组信息'},
          {value:'8',text:'质疑记录导出'},
          {value:'9',text:'公式配置'},
          {value:'11',text:'项目方案导出'},
          {value:'12',text:'受试者审核状态'},
          {value:'16',text:'知情同意书导出'},
        ],
        columns:[
          {
            title: '导出时间',
            width: 150,
            dataIndex: 'createTime',
          },
          {
            title: '导出人',
            width: 120,
            dataIndex: 'createName',
          },
          {
            title: '数据类型',
            width: 150,
            dataIndex: 'type',
            customRender: (t, r, index)=> {
              return this.getTypeText(t);
            }
          },
          {
            title: '状态',
            width: 80,
            dataIndex: 'status',
            customRender: function (t, r, index) {
              let result = '创建中'
              if(t==='2')
              {
                result='完成'
              }
              else if(t==='3')
              {
                result='失败'
              }
              return result;
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: 120,
            align: "center",
            scopedSlots: {customRender: 'action'}
          }
        ],
        disableMixinCreated:true,
        selectType:{},
        url:{
          list:'/export/projectExport/pageList',
          delete: "/export/projectExport/delete",
        },
        timer:null,
      }
    },
    mounted(){
      this.baseQueryParam = {projectId:this.projectId}
      this.loadData()
      if(this.timer==null){
        // this.timer = setInterval(() => {
        //   //需要定时执行的代码
        //   this.loadData()
        // },5000)
      }
    },
    methods:{
      ...mapGetters(["userInfo"]),
      getTypeText(value){
        return this.getTypeByValue(value).text
      },
      getTypeByValue(value){
        let result={}
        this.typeList.forEach(item=>{
          if(item.value===value){
            result = item
          }
        })
        return result
      },
      queryParamDateRangeChange(date, dateString){
        this.queryParam.startCreateTime = dateString[0]
        this.queryParam.endCreateTime = dateString[1]
      },
      exportConfig(value){
        const selectType=this.getTypeByValue(value)
        selectType.data = {}
        this.selectType= selectType
      },
      back(){
        this.selectType={}
        this.loadData()
      },
      handleView(record){
        const selectType=this.getTypeByValue(record.type)
        selectType.data = record
        this.selectType= selectType
      },
      handleDownload(record){
        let s = record.path?record.path.split('/'):['1']
        let ss = s[s.length-1];
        s = ss.split("\\");
        ss = s[s.length-1];
        if(s.length>0){
          downloadFile('/sys/common/static/'+record.path,s[s.length-1])
        }
      }
    },
    destroyed(){
      clearInterval(this.timer)
    }
  }
</script>

<style scoped lang="less">
.export-center{
  .btn{
    margin-left: 15px;
    margin-bottom: 10px;
  }
  .title{
    font-weight: bold;
    font-size: 16px;
  }
  .row{
    margin-top: 30px;
  }
  .row2{
    margin-top: 20px;
  }
  .search-panel{
    text-align: right;
    margin-bottom: 10px;
    .search-item-com{
      margin-left: 5px;
    }
  }
}
</style>